import { widgetRegistry } from '../../infrastructure/registry/WidgetRegistry';

// KPI Widgets (Milestone 2)
import { AdminTotalLeadsWidget, adminTotalLeadsConfig } from './AdminTotalLeadsWidget';
import { AdminLeadsTodayWidget, adminLeadsTodayConfig } from './AdminLeadsTodayWidget';
import { AdminLeadsThisWeekWidget, adminLeadsThisWeekConfig } from './AdminLeadsThisWeekWidget';
import { AdminActiveEmployeesWidget, adminActiveEmployeesConfig } from './AdminActiveEmployeesWidget';
import { AdminScansTodayWidget, adminScansTodayConfig } from './AdminScansTodayWidget';
import { AdminConvertedWidget, adminConvertedConfig } from './AdminConvertedWidget';
import { AdminLeadVelocityWidget, adminLeadVelocityConfig } from './AdminLeadVelocityWidget';
import { AdminPipelineHealthWidget, adminPipelineHealthConfig } from './AdminPipelineHealthWidget';
import { AdminTeamLeaderboardWidget, adminTeamLeaderboardConfig } from './AdminTeamLeaderboardWidget';

// Operational List Widgets — consolidated onto the CANONICAL employee widgets
// (one component per widget id). The former business/list/* duplicates that
// shared these same ids are no longer registered (audit: duplicate removal).
import { RunningJobsWidget, runningJobsConfig } from '../employee/RunningJobsWidget';
import { PendingTasksWidget, pendingTasksConfig } from '../employee/PendingTasksWidget';
import { ActiveProjectsWidget, activeProjectsConfig } from '../employee/ActiveProjectsWidget';
import { AnnouncementsWidget, announcementsConfig } from '../employee/AnnouncementsWidget';
import { RecentActivitiesWidget, recentActivitiesConfig } from '../employee/RecentActivitiesWidget';

export function registerAdminWidgets() {
  // ── KPI Row ──────────────────────────────────────────────────────────────
  widgetRegistry.register(adminTotalLeadsConfig,      AdminTotalLeadsWidget);
  widgetRegistry.register(adminLeadsTodayConfig,      AdminLeadsTodayWidget);
  widgetRegistry.register(adminLeadsThisWeekConfig,   AdminLeadsThisWeekWidget);
  widgetRegistry.register(adminActiveEmployeesConfig, AdminActiveEmployeesWidget);
  widgetRegistry.register(adminScansTodayConfig,      AdminScansTodayWidget);
  widgetRegistry.register(adminConvertedConfig,       AdminConvertedWidget);
  widgetRegistry.register(adminLeadVelocityConfig,    AdminLeadVelocityWidget);
  widgetRegistry.register(adminPipelineHealthConfig,  AdminPipelineHealthWidget);

  // ── Analytics ─────────────────────────────────────────────────────────────
  widgetRegistry.register(adminTeamLeaderboardConfig, AdminTeamLeaderboardWidget);

  // ── Operational Lists Row (canonical, deduplicated) ───────────────────────
  widgetRegistry.register(runningJobsConfig,          RunningJobsWidget);
  widgetRegistry.register(pendingTasksConfig,         PendingTasksWidget);
  widgetRegistry.register(activeProjectsConfig,       ActiveProjectsWidget);
  widgetRegistry.register(announcementsConfig,        AnnouncementsWidget);
  widgetRegistry.register(recentActivitiesConfig,     RecentActivitiesWidget);
}
